import { z } from "zod";
import { BaseFilterInputSchema } from "../BaseFilterInput";

export const GetMyReportsExecutionHistoryInputSchema = BaseFilterInputSchema.extend({
    getAll: z.boolean().nullable().default(null),
    reportId: z.number().nullable().default(null),
    historyId: z.string().nullable().default(null),
    includeAutomatedReports: z.boolean().default(false),
    userName: z.string().nullable().default(null),
});

export type GetMyReportsExecutionHistoryInput = z.infer<typeof GetMyReportsExecutionHistoryInputSchema>;